namespace advisorop.components.servicer {

    export class CuCustodianController {
        custodianId: number;
        custodianIdESDM: number = 0;
        custodian: domains.ICustodian = {
            address: {}
        };
        custodianName: string;
        externalSystemDataMapping: domains.IExternalSystemDataMapping;

        externalSystems: domains.IExternalSystem[];
        externalSystem: domains.IExternalSystem;

        mappingType: domains.ExternalMappingType = domains.ExternalMappingType.CUSTODIANID_TO_CUSTODIANID;

        externalSystemDataMappings: domains.IExternalSystemDataMapping[] = [];

        lovs: domains.ILOV[] = [];
        documentTypes: domains.ILOV[] = [];
        selDocumentType: domains.ILOV = {};
        reportTemplates: domains.IReportTemplate[] = [];
        custodianReportTemplates: domains.IReportTemplate[] = [];
        selCustodianReportTemplate: domains.IReportTemplate = {};
        templates: domains.ICustodianDocument[] = [];
        custodianDocument: domains.ICustodianDocument = {};
        dgTemplates: DevExpress.ui.dxDataGridOptions;
        linkTemplates: boolean = true;

        onCustodianCreated: any;
        onCustodianModified: any;
        onCancel: any;
        mappingExternalSystemType = domains.ExternalSystemType.BACK_OFFICE;


        constructor(private servicerService: services.ServicerService, private generalService: services.GeneralService) {

            this.dgTemplates = {
                export: {
                    enabled: true,
                    fileName: "Templates"
                },
                bindingOptions: {
                    dataSource: "vm.templates"
                },
                paging: { pageSize: 5 },
                rowAlternationEnabled: true,
                showBorders: true,
                showColumnLines: true,
                columnAutoWidth: false,
                allowColumnReordering: false,
                noDataText: "There are no custodian documents linked",
                allowColumnResizing: false,
                columnChooser: {
                    enabled: false,
                    title: "Select columns"
                },
                filterRow: { visible: false },
                headerFilter: { visible: false },
                searchPanel: {
                    visible: false,
                    placeholder: "Search..."
                },
                wordWrapEnabled: true,
                columns: [
                    { dataField: "type", caption: "Document Type" },
                    { dataField: "name", caption: "Document Name" },
                    { dataField: "id", caption: "Actions", cellTemplate: "btnActions", cssClass: "tblOverflow", width: "60" }
                ],

            };
        }

        loadCustodian(): void {
            this.servicerService.getCustodian(this.custodianId)
                .then(data => {
                    this.custodian = data.data;
                    this.custodianIdESDM = data.data.id;
                    if (!this.custodian.address) {
                        this.custodian.address = { street: "" };
                    }
                })
                .catch(err => {
                    this.custodianIdESDM = 0;
                    toastr.error("Custodian could not be loaded. Error " + err.status + ": " + err.data);
                });
        };

        loadLovs(): void {
            this.generalService.getLOVs()
                .then((data) => {

                    this.lovs = data;

                    this.documentTypes = this.lovs.filter(v => (v.lovType == domains.LovType.DOCUMENT_TYPE && v.extra1 === '1' && v.extra2 === '2' && v.extra3 === '1'))
                        .sort((a, b) => (a.name > b.name) ? 1 : ((b.name > a.name) ? -1 : 0));
                    this.loadReportTemplates();
                });
        }

        loadReportTemplates() {
            this.servicerService.getReportTemplates()
                .then((data) => {

                    this.reportTemplates = data.data;
                });
        }

        cancel(): void {
            this.onCancel();
        }

        createCustodian(): void {
            this.servicerService.createCustodian(this.custodian)
                .then(data => {
                    this.onCustodianCreated({ custodian: data.data });
                    this.custodian = { address: { street: "" } };
                    this.createUpdateExternalMapping(data.data.id);
                })
                .catch(err => {
                    toastr.error("Custodian could not be created. Error " + err.status + ": " + err.data);
                });
        };

        saveCustodian(): void {
            //console.log("custodian saving...", this.custodian);
            this.servicerService.updateCustodian(this.custodian)
                .then(data => {
                    this.onCustodianModified({ custodian: data.data });
                    this.custodian = { address: {} };
                    this.createUpdateExternalMapping(data.data.id);
                })
                .catch(err => {
                    toastr.error("Custodian could not be saved. Error " + err.status + ": " + err.data);
                });
        };

        onAddressChanged(address: domains.IAddress): void {
            //console.log("CUSTODIAN: Address has been changed...", address);
            this.custodian.address = address;

        }

        $onInit(): void {
            //this.loadExternalSystems();
        }

        $onChanges(evt): void {

            for (var key in evt) {
                //console.log("key", key);
                if (key === "custodian") {
                    //console.log("CuCustodian: onChanges key=custodian:", this.custodian);
                    if (this.custodian && !this.custodian.address) {
                        this.custodian.address = {};
                    }
                }

                if (key === "custodianName") {
                    this.getExternalMappingType();
                    if (this.custodianName !== undefined) {
                        this.custodianIdESDM = this.custodian.id;
                        this.templates = this.custodian.custodianDocuments;
                        this.dgTemplates.dataSource = this.templates;
                        //if (this.custodian.name == "Pershing") this.linkTemplates = true;
                        this.loadLovs();
                    } // else {
                        //this.linkTemplates = false;
                    //}
                }
            }
        }

        onDocumentTypeChanged(): void {
            this.custodianReportTemplates = this.reportTemplates.filter(x => x.documentType === this.selDocumentType.value);
        }

        onTemplateChanged(): void {
        }

        addCustodianTemplate() {

            if (typeof this.selCustodianReportTemplate.id === "undefined") {
                toastr.warning("Please choose document template");
            }

            //console.log("DOC TYPE IS ", this.selDocumentType);

            this.custodianDocument = {
                id: 0,
                custodianId: this.custodian.id,
                documentId: this.selCustodianReportTemplate.id,
                name: this.selCustodianReportTemplate.name,
                type: this.documentTypes.filter(x => x.value === this.selCustodianReportTemplate.documentType)[0].name,
                platform: domains.ReportingPlatform[domains.ReportingPlatform[this.selCustodianReportTemplate.platform]],
                uid: this.selCustodianReportTemplate.uid
            }
            //console.log("Custodian document: ", this.custodianDocument);
            if (typeof this.custodian.custodianDocuments === "undefined") this.custodian.custodianDocuments = [];
            this.custodian.custodianDocuments.push(this.custodianDocument);
            this.templates = this.custodian.custodianDocuments;
        }

        deleteTemplate(tmp: domains.ICustodianDocument) {
            //console.log("$ template", tmp);

            var ind = this.templates.indexOf(tmp);
            if (ind >= 0) {
                this.templates.splice(ind, 1);
            }

        }

        loadExternalSystems() {

            this.generalService.getExternalSystems().then(data => {
                //console.log(data.data);
                this.externalSystems = data.data;
            });
        }

        getExternalMappingType() {
            //if (this.custodian && this.custodian.id > 0)
            //    this.servicerService.getExternalSystemDataMapping(this.custodian.id, this.mappingType).then(data => {
            //        console.log("external systrem data mapping", data.data);
            //        this.externalSystemDataMapping = data.data;
            //        if (this.externalSystemDataMapping && this.externalSystemDataMapping.id > 0)
            //            this.externalSystem = this.externalSystems.filter(es => es.id == this.externalSystemDataMapping.externalSystemId)[0];
            //        else
            //            this.externalSystem = null;
            //    });
        }

        createUpdateExternalMapping(custodianId: number) {
            if (this.externalSystemDataMappings.length > 0) {
                for (var i = 0; i < this.externalSystemDataMappings.length; i++) {
                    if (this.externalSystemDataMappings[i].advisorOpDataFieldId == 0)
                        this.externalSystemDataMappings[i].advisorOpDataFieldId = custodianId;
                }

                this.servicerService.createUpdateExternalSystemDataMappings(this.externalSystemDataMappings)
                    .then(data => {
                    }, err => this.generalService.showError(err));
            }
        }

        externalMappingChanged(data: domains.IExternalSystemDataMapping[]) {
            this.externalSystemDataMappings = data;

            //console.log("externalSystemDataMappings", data);
        }

    }

    class CuCustodian implements ng.IComponentOptions {

        public bindings: any;
        public controller: any;
        public controllerAs: string;
        public templateUrl: string;

        constructor() {
            this.bindings = {
                custodian: "=",
                custodianName: "<",
                onCustodianCreated: "&",
                onCustodianModified: "&",
                onCancel: "&"
            };
            this.controller = ["servicerService", "generalService", CuCustodianController];
            this.controllerAs = "vm";
            this.templateUrl = 'spa/servicer-module/components/cu-custodian.html';
        }
    }
    angular.module(Constants.APP).component("cuCustodian", new CuCustodian());

}